import { render, staticRenderFns } from "./ProteinAdd.vue?vue&type=template&id=866ebfe8&scoped=true&"
import script from "./ProteinAdd.vue?vue&type=script&lang=js&"
export * from "./ProteinAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProteinAdd.vue?vue&type=style&index=0&id=866ebfe8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866ebfe8",
  null
  
)

export default component.exports